import { levers, shapes, categories } from "./data";
import Select from "components/Select";
import styles from "./App.module.scss";
import { useArtSpecs } from "./Context";

const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

// The EDG ID is the seed — filling it in keeps a random result reproducible.
const randomId = () => Math.random().toString(36).slice(2, 8).toUpperCase();

export default function Controls() {
  const { inputs, setInputs } = useArtSpecs();

  const randomize = () =>
    setInputs({
      id: randomId(),
      lever: pick(levers),
      shape: pick(shapes),
      category: pick(categories),
    });

  return (
    <div className={styles.controlsCol}>
      <form className={styles.panel}>
        <div className={styles.panelHead}>Product specs</div>
        <fieldset>
          <label htmlFor="edg-id">EDG ID</label>
          <input id="edg-id" onChange={(e) => setInputs({ id: e.target.value })} value={inputs.id ?? ""} />
        </fieldset>
        <fieldset>
          <Select id="lever" label="Lever" onChange={(lever) => setInputs({ lever })} options={levers} value={inputs.lever} />
        </fieldset>
        <fieldset>
          <Select id="shape" label="Shape" onChange={(shape) => setInputs({ shape })} options={shapes} value={inputs.shape} />
        </fieldset>
        <fieldset style={{ marginBottom: 0 }}>
          <Select
            id="category"
            label="Category"
            onChange={(category) => setInputs({ category })}
            options={categories}
            value={inputs.category}
          />
        </fieldset>
      </form>

      <button type="button" className={styles.generate} onClick={randomize}>
        Generate random design
      </button>
    </div>
  );
}
